import React from 'react';
import styles from './cardTitle.module.css';
import { Link } from 'react-router-dom';

export default ({ title, tip, fn }: { title: string; tip: string; fn: Function | null }) => {
  const arr1 = [
    'everyoneIsWatching',
    'newArrival',
    'editorRecommendation',
    'socialSciences',
    'management',
    'novel',
    'life',
    'tool',
    'boysFavorite',
    'girlsFavorite',
    'finishedWork',
    'booklist',
    'freebook',
    'hotRecommendation',
    'newBookExpress',
  ];
  const arr2 = [
    '大家都在看',
    '最新上架',
    '编辑推荐',
    '社科',
    '经管',
    '小说',
    '生活',
    '工具',
    '男生最爱',
    '女生最爱',
    '完结作品',
    '全部书单',
    '免费图书',
    '热门推荐',
    '新书速递',
    '包月书库',
  ];

  function linkText() {
    if (title === '包月免费读') {
      return `/monthlyZone`;
    } else if (title === '包月书库') {
      return '/classify?type=monthlyLib';
    } else {
      const index = arr2.indexOf(title);
      if (index >= 0) {
        return `/shudanDetails?type=${arr1[index]}`;
      }
    }
    return '';
  }

  function tipRender() {
    if (tip) {
      if (fn) {
        return (
          <div
            className={styles.cardTitleRight}
            onClick={() => {
              fn();
            }}
          >
            <span>{tip}</span>
            <div className="iconfont icon-arrow-left" id={styles.icon}></div>
          </div>
        );
      } else {
        return (
          <Link to={linkText()}>
            <div className={styles.cardTitleRight}>
              <span>{tip}</span>
              <div className="iconfont icon-arrow-left" id={styles.icon}></div>
            </div>
          </Link>
        );
      }
    }
  }

  return (
    <>
      <div className={styles.cardTitle}>
        <div className={styles.cardTitleLeft}>{title}</div>
        {tipRender()}
      </div>
      <div className={styles.line}></div>
    </>
  );
};
